<template>
  <div
    class="pesquisa-drawer__content"
    style="
      height: 100%;
      width: auto;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 1.5rem;
      gap: 1.5rem;
    "
  >
    <div class="pesquisa-drawer__content-top" style="text-align: center">
      <b>Resposta enviada</b>
    </div>
    <div
      class="pesquisa-drawer__content-middle"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
      "
    >
      <el-image
        :src="concluido"
        alt="Concluído"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 147px;
        "
      />
      <p>Obrigado por participar da nossa pesquisa!</p>
    </div>
    <div
      class="pesquisa-drawer__content-bottom"
      style="display: flex; justify-content: center"
    >
      <vc-button
        size="large"
        filled
        @click="emit('close')"
        style="width: 170px; height: 35px"
        >Fechar</vc-button
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import concluido from "../assets/concluido.png";

const emit = defineEmits<{
  (e: "close"): void;
}>();
</script>

<style scoped></style>
